// Last known state of the settings integration cards (Stripe, PMS/locks, Claude).
//
// SWR keeps nothing across a page reload, so every card used to render "Configure"
// until its request answered, then flip to "Connected". Remembering the last answer
// lets the card render the right state on the first paint; the live request then
// confirms or corrects it in the background.
//
// Keyed by company: two accounts sharing a browser never see each other's state.
// Only statuses are kept, never credentials. Cleared on sign-out (tokenStore).

export const INTEGRATION_STATUS_KEY = 'hostea:integrationStatus';

// The company is known from the stored session before any request answers
const sessionCompanyId = () => {
  try { return JSON.parse(localStorage.getItem('user') || 'null')?.companyId || null; } catch (e) { return null; }
};

const readAll = () => {
  try { return JSON.parse(localStorage.getItem(INTEGRATION_STATUS_KEY) || '{}') || {}; } catch (e) { return {}; }
};

export const readIntegrationStatus = (name, companyId = sessionCompanyId()) => {
  if (!companyId) return undefined;
  return readAll()[String(companyId)]?.[name];
};

export const writeIntegrationStatus = (name, value, companyId = sessionCompanyId()) => {
  if (!companyId) return;
  try {
    const all = readAll();
    all[String(companyId)] = { ...all[String(companyId)], [name]: value };
    localStorage.setItem(INTEGRATION_STATUS_KEY, JSON.stringify(all));
  } catch (e) { /* storage blocked: the cards simply wait for the network */ }
};
